import analyticsIcon from "./../../assests/img/analytics-icon.svg";
import analyticsFilledIcon from "./../../assests/img/analytics-filled-icon.svg";
import dashboardIcon from "./../../assests/img/dashboard-icon.svg";
import dashboardFilledIcon from "./../../assests/img/dashboard-filled-icon.svg";
import smartBuilderIcon from "./../../assests/img/smart-builder-icon.svg";
import abTestingIcon from "./../../assests/img/ab-testing-icon.svg";
import abTestingFilledIcon from "./../../assests/img/ab-testing-filled-icon.svg";
import starIcon from "./../../assests/img/star-icon.svg";
import starFilledIcon from "./../../assests/img/star-filled-icon.svg";
import smartBuilderFilledIcon from "./../../assests/img/smart-builder-filled-icon.svg";
import rulesIcon from "./../../assests/img/rules-icon.svg";
import rulesFilledIcon from "./../../assests/img/rules-filled-icon.svg";
import substitutionIcon from "./../../assests/img/substitution-icon.svg";
import substitutionFilledIcon from "./../../assests/img/substitution-fulfilled-icon.svg";
import categoryRelevancyIcon from "./../../assests/img/category-relevancy.svg";
import categoryRelevancyFilledIcon from "./../../assests/img/category-relevancy-filled.svg";
import productsIcon from "./../../assests/img/product-icon.svg";
import mappingIcon from "./../../assests/img/mapping-icon.svg";
import mappingFilledIcon from "./../../assests/img/mapping-filled-icon.svg";
import productsFilledIcon from "./../../assests/img/product-filled-icon.svg";
import dataReviewIcon from "./../../assests/img/data-review.svg";
import dataReviewFilledIcon from "./../../assests/img/data-filled-review-icon.svg";
import importDataIcon from "./../../assests/img/import-data.svg";
import importDataFilledIcon from "./../../assests/img/import-filled-data-icon.svg";
import categoryIcon from "./../../assests/img/category-icon.svg";
import categoryFilledIcon from "./../../assests/img/category-filled-icon.svg";
import atributeIcon from "./../../assests/img/attributes-icon.svg";
import atributeFilledIcon from "./../../assests/img/attributes-filled-icon.svg";
import pdwIcon from "./../../assests/img/pdw-icon.svg";
import pdwFilledIcon from "./../../assests/img/pdw-filled-icon.svg";
import partyIcon from "./../../assests/img/party-icon.svg";
import partyFilledIcon from "./../../assests/img/party-filled-icon.svg";
import settingIcon from "./../../assests/img/setting-icon.svg";
import settingFilledIcon from "./../../assests/img/setting-filled-icon.svg";
import adapterIcon from "./../../assests/img/adapter-icon.svg";
import adapterFilledIcon from "./../../assests/img/adapter-filled-icon.svg";
import listFilledIcon from "./../../assests/img/list-filled-icon.svg"
import productCardsIcon from "./../../assests/img/product-cards-icon.svg";
import productCardsFilledIcon from "./../../assests/img/product-cards-filled-icon.svg";
import resolveIcon from "./../DesignSystem/Iconography/resolve-icon.svg";
const categoryPath: string = "/gms/categories";
const attributePath: string = "/gms/attributes";
const listPath: string = "/gms/lists"
const productPath: string = "/gms/products";
const mappingPath: string = "/gms/mapping";
const rulePath: string = "/gms/compatibilities";
const pdwPath: string = "/gms/pdw";
const dataReviewPath: string = "/catalog/manage";
const builderV2Path: string = "/gms/builder";
const isrPath: string = "/gms/isr";
const guidePath: string = "/gms/guide";
const abTestingPath: string = "/gms/ab";
const ARSPath: string = "/gms/commend";
const Commend3Path: string = "/gms/commend-v3";
const dataImport: string = "/gms/connectors";
//const partyPath: string = "/gms/party";
const managePartyPath: string = "/admin/party/manage";
// const promotionPath: string = "/admin/promotion";
const settingsPath: string = "/admin/settings";
// Admin › Adapters (AB#14369). First item of the Admin group; hidden by MenuItem unless `gmsadapter_read` is granted.
const adaptersPath: string = "/admin/adapters";
export const performancePath: string = "/gms/performance";
export const productCardsPath: string = "/gms/product_cards";
const productMatchPath: string = "/gms/product(s)?";
const computedSubstitutionPath = "/gms/substitutions";
const resolvePath: string = "/gms/resolve";
const categoryRelevancyPath = "/gms/category_relevancy";

type MenuItem = {
  menuName: string;
  path: string;
  icon: string;
  filledIcon: string;
  matchPath?: string;
}

type SidebarMenuGroup = {
  headerName: string;
  menuItems: MenuItem[];
}
export const sidebarMenu: SidebarMenuGroup[] = [
  {
    headerName: "",
    menuItems: [
      //{
      //  menuName: "Dashboard",
      //  path: "/dashboard",
      //  icon: dashboardIcon,
      //  filledIcon: dashboardFilledIcon,
      //},
      {
        menuName: "Performance",
        path: performancePath,
        icon: analyticsIcon,
        filledIcon: analyticsFilledIcon,
      },
    ],
  },
  {
    headerName: "Applications",
    menuItems: [
      // { menuName: "Advanced Recommender", path: "", icon: advancedRecommenderIcon, filledIcon: advancedRecommenderFilledIcon,},
      // { menuName: "Bundlers", path: "", icon: bundlerIcon, filledIcon: bundlerFilledIcon },
      {
        menuName: "Guide",
        path: guidePath,
        icon: smartBuilderIcon,
        filledIcon: smartBuilderFilledIcon,
      },
      {
        menuName: "Commend",
        path: ARSPath,
        icon: starIcon,
        filledIcon: starFilledIcon,
      },
      // {
      //   menuName: "Commend 3.0",
      //   path: Commend3Path,
      //   icon: starIcon,
      //   filledIcon: starFilledIcon,
      // },
      // {
      //   menuName: "Configure",
      //   path: isrPath,
      //   icon: smartBuilderIcon,
      //   filledIcon: smartBuilderFilledIcon,
      // },
      {
        menuName: "Smart Builder 2",
        path: builderV2Path,
        icon: smartBuilderIcon,
        filledIcon: smartBuilderFilledIcon,
      },
      {
        menuName: "Resolve",
        path: resolvePath,
        icon: resolveIcon,
        filledIcon: resolveIcon,
      },
    ],
  },
  {
    // Sits directly below Applications (from branch update_latest_changes, 2026-09-09).
    // "Product Cards" has no matchPath override, so react-router's non-exact match
    // keeps it active inside the Card Editor too.
    headerName: "Product Display",
    menuItems: [
      {
        menuName: "Product Cards",
        path: productCardsPath,
        icon: productCardsIcon,
        filledIcon: productCardsFilledIcon,
      },
    ],
  },
  {
    headerName: "Real Intelligence™",
    menuItems: [
      {
        menuName: "Compatibility",
        path: rulePath,
        icon: rulesIcon,
        filledIcon: rulesFilledIcon,
      },
      {
        menuName: "Substitution",
        path: computedSubstitutionPath,
        icon: substitutionIcon,
        filledIcon: substitutionFilledIcon,
      },
      {
        menuName: "Category Relevancy",
        path: categoryRelevancyPath,
        icon: categoryRelevancyIcon,
        filledIcon: categoryRelevancyFilledIcon,
      },
    ],
  },
  {
    headerName: "Optimization",
    menuItems: [
      {
        menuName: "A/B Testing",
        path: abTestingPath,
        icon: abTestingIcon,
        filledIcon: abTestingFilledIcon,
      }
    ],
  },
  {
    headerName: "Taxonomy",
    menuItems: [
      {
        menuName: "Categories",
        path: categoryPath,
        icon: categoryIcon,
        filledIcon: categoryFilledIcon,
      },
      {
        menuName: "Attributes",
        path: attributePath,
        icon: atributeIcon,
        filledIcon: atributeFilledIcon,
      },
      {
        menuName: "Lists",
        path: listPath,
        icon: listFilledIcon,
        filledIcon: listFilledIcon,
      },
    ],
  },
  {
    headerName: "Data Import",
    menuItems: [
      {
        menuName: "Connectors",
        path: dataImport,
        icon: importDataIcon,
        filledIcon: importDataFilledIcon,
      },
      {
        menuName: "PDW",
        path: pdwPath,
        icon: pdwIcon,
        filledIcon: pdwFilledIcon,
      },
    ],
  },
  {
    headerName: "Catalog Management",
    menuItems: [
      {
        menuName: "Review",
        path: dataReviewPath,
        icon: dataReviewIcon,
        filledIcon: dataReviewFilledIcon,
      },
    ],
  },
  {
    headerName: "Catalog",
    menuItems: [
      {
        menuName: "Products",
        path: productPath,
        icon: productsIcon,
        filledIcon: productsFilledIcon,
        matchPath: productMatchPath,
      },
      {
        menuName: "Mapping",
        path: mappingPath,
        icon: mappingIcon,
        filledIcon: mappingFilledIcon
      },
    ],
  },
  {
    headerName: "Admin",
    menuItems: [
      //  { menuName: "Manage Parties", path: partyPath, icon: partyIcon, filledIcon: partyFilledIcon, },
      {
        menuName: "Adapters",
        path: adaptersPath,
        icon: adapterIcon,
        filledIcon: adapterFilledIcon,
      },
      {
        menuName: "Manage Parties",
        path: managePartyPath,
        icon: partyIcon,
        filledIcon: partyFilledIcon,
      },
      {
        menuName: "Settings",
        path: settingsPath,
        icon: settingIcon,
        filledIcon: settingFilledIcon,
      },
    ],
  },
];